import { useObjectMemo } from "byzantine";
import { useLocalization } from "@fluent/react";

const useQuickActionsEditorLabels = () => {
  const { l10n } = useLocalization();

  return useObjectMemo({
    // Main title and description
    editQuickActionsTitle: l10n.getString(
      "quick-actions-edit-title",
      {},
      "Edit quick actions"
    ),
    editQuickActionsDescription: l10n.getString(
      "quick-actions-edit-description",
      {},
      "Send Money is required (in the first position). Add up to 4 more actions. Drag to reorder."
    ),

    // Section headers
    yourQuickActionsTitle: l10n.getString(
      "quick-actions-your-actions-title",
      {},
      "Your quick actions"
    ),
    actionLibraryTitle: l10n.getString(
      "quick-actions-library-title",
      {},
      "Action library"
    ),

    // Buttons and controls
    addButtonLabel: l10n.getString("quick-actions-add-button", {}, "Add"),
    reorderAriaLabel: l10n.getString(
      "quick-actions-reorder-aria-label",
      {},
      "Reorder"
    ),

    // Status texts
    requiredSuffix: l10n.getString(
      "quick-actions-required-suffix",
      {},
      "required"
    ),
    limitReachedTooltip: l10n.getString(
      "quick-actions-limit-reached-tooltip",
      {},
      "You have reached your limit of quick actions"
    ),

    // Drag and drop announcements
    dragPickedUp: (actionLabel: string) =>
      l10n.getString(
        "quick-actions-drag-picked-up",
        { actionLabel },
        `Picked up ${actionLabel}.`
      ),
    dragMoving: (activeLabel: string, overLabel: string) =>
      l10n.getString(
        "quick-actions-drag-moving",
        { activeLabel, overLabel },
        `Moving ${activeLabel} before ${overLabel}.`
      ),
    dragDropped: (activeLabel: string, overLabel?: string) => {
      if (overLabel) {
        return l10n.getString(
          "quick-actions-drag-dropped-before",
          { activeLabel, overLabel },
          `Dropped ${activeLabel} before ${overLabel}.`
        );
      } else {
        return l10n.getString(
          "quick-actions-drag-dropped",
          { activeLabel },
          `Dropped ${activeLabel}.`
        );
      }
    },
    dragCancelled: (actionLabel: string) =>
      l10n.getString(
        "quick-actions-drag-cancelled",
        { actionLabel },
        `Cancelled dragging ${actionLabel}.`
      ),

    // Default fallback
    itemFallback: l10n.getString("quick-actions-item-fallback", {}, "item"),
  });
};

export default useQuickActionsEditorLabels;
